export const NOTIFICATION_MODULE_NAMESPACE = 'notification';
export const NOTIFICATION_GET_NOTIFICATIONS = 'NOTIFICATION_GET_NOTIFICATIONS';
export const NOTIFICATION_SET_NOTIFICATIONS = 'NOTIFICATION_SET_NOTIFICATIONS';
export const NOTIFICATION_SET_UNREAD_NOTIFICATIONS = 'NOTIFICATION_SET_UNREAD_NOTIFICATIONS';
export const NOTIFICATION_MARKAS_READ = 'NOTIFICATION_MARKAS_READ';
export const NOTIFICATION_CURRENT_CHANNEL = 'NOTIFICATION_CURRENT_CHANNEL';
export const NOTIFICATION_GET_UNREAD = 'NOTIFICATION_GET_UNREAD';
export const NOTIFICATION_INCREASE_UNREAD_MESSAGE = 'NOTIFICATION_INCREASE_UNREAD_MESSAGE';
export const NOTIFICATION_DECREASE_UNREAD_MESSAGE = 'NOTIFICATION_DECREASE_UNREAD_MESSAGE';
export const NOTIFICATION_GET_UNREAD_NOTIFICATIONS = 'NOTIFICATION_GET_UNREAD_NOTIFICATIONS';
export const NOTIFICATION_MARK_ALL_AS_READ = 'NOTIFICATION_MARK_ALL_AS_READ';
export const NOTIFICATION_DELETE_ALL = 'NOTIFICATION_DELETE_ALL';

export const NOTIFICATION_SET_UNREAD_NOTIFICATION_RESOURCE = 'NOTIFICATION_SET_UNREAD_NOTIFICATION_RESOURCE';
export const NOTIFICATION_SET_NOTIFICATIONS_LOADING = 'NOTIFICATION_SET_NOTIFICATIONS_LOADING';
export const NOTIFICATION_SET_UNREAD_NOTIFICATIONS_LOADING = 'NOTIFICATION_SET_UNREAD_NOTIFICATIONS_LOADING';
export const NOTIFICATION_SET_NOTIFICATIONS_FAILED = 'NOTIFICATION_SET_NOTIFICATIONS_FAILED';
export const NOTIFICATION_SET_UNREAD_NOTIFICATIONS_FAILED = 'NOTIFICATION_SET_UNREAD_NOTIFICATIONS_FAILED';
export const NOTIFICATION_UPDATE_GET_NOTIFICATION_PARAMETER = 'NOTIFICATION_UPDATE_GET_NOTIFICATION_PARAMETER';
export const NOTIFICATION_GET_NOTIFICATION_INFINITY_LOADING = 'NOTIFICATION_GET_NOTIFICATION_INFINITY_LOADING';
export const NOTIFICATION_UPDATE_GET_UNREAD_NOTIFICATION_PARAMETER = 'NOTIFICATION_UPDATE_GET_UNREAD_NOTIFICATION_PARAMETER';
export const NOTIFICATION_GET_UNREAD_NOTIFICATION_INFINITY_LOADING = 'NOTIFICATION_GET_UNREAD_NOTIFICATION_INFINITY_LOADING';
export const NOTIFICATION_MARK_AS_READ_BY_ID = 'NOTIFICATION_MARK_AS_READ_BY_ID';



// WEBPACK FOOTER //
// ./src/store/notification/notification-types.store.ts